module.exports = __webpack_public_path__ + "static/media/ic_purchase.3a915e5f.svg";